import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'
import Swal from 'sweetalert2'

@Component({
	selector: 'duplicate-nodes',
	templateUrl: './duplicate-nodes.component.html',
	styleUrls: ['./duplicate-nodes.component.scss']
})

export class DuplicateNodesComponent implements OnInit, OnChanges, OnDestroy {

	@Input() type = ''
	@Input() id = 0
	@Input() name = ''
	@Input() parent = 0
	// @Input() unit = 0
	// @Input() lesson = 0
	userID = 0
	
	// nodeType : 'course' | 'unit' | 'lesson' = 'course'
	// nodeName = ''
	
	sourceCategories: any[] = []
	sourceCourses: any[] = []
	sourceUnits: any[] = []
	sourceLessons: any[] = []
	sourceCategory = 0
	sourceCourse = 0
	sourceUnit = 0
	sourceLesson = 0
	
	duplicateName = ''
	showDestination = false
	destinationCategories: any[] = []
	destinationCourses: any[] = []
	destinationUnits: any[] = []
	destinationLessons: any[] = []
	destinationCategory = 0
	destinationCourse = 0
	destinationUnit = 0
	
	duplicating = false
	duplicateSuccess = false
	duplicateError = false

	getCategoriesSub = new Subscription
	getCategoryCoursesSub = new Subscription
	getCourseUnitsSub = new Subscription
	getUnitLessonsSub = new Subscription
	duplicateNodeSub = new Subscription

	constructor(private dataService: ApiService) { }

	ngOnInit(): void {
		this.userID = this.dataService.getUserID()
	}

	ngOnChanges(): void {
		this.duplicating = false
		this.duplicateSuccess = false
		this.duplicateError = false

		this.updateName()
		
		if (this.type === 'course') {
			this.sourceCourse = this.id
			if (this.parent > 0) this.sourceCategory = this.parent
			// if (this.brainscorm) this.destinationCategory = 14 // ID Categoría DUPLICADOS ESTANDAR
			this.destinationCategory = this.sourceCategory
		} else if (this.type === 'unit') {
			this.sourceUnit = this.id
			if (this.parent > 0) this.sourceCourse = this.parent
			this.destinationCourse = this.sourceCourse
		} else if (this.type === 'lesson') {
			this.sourceLesson = this.id
			if (this.parent > 0) this.sourceUnit = this.parent
			this.destinationUnit = this.sourceUnit
		}

		this.getCategories()
		this.getCategoryCourses('source')
		this.getCategoryCourses('destination')
		// this.getCourseUnits()
		// this.getUnitLessons()
	}

	ngOnDestroy(): void {
		this.getCategoriesSub?.unsubscribe()
		this.getCategoryCoursesSub?.unsubscribe()
		this.getCourseUnitsSub?.unsubscribe()
		this.getUnitLessonsSub?.unsubscribe()
		this.duplicateNodeSub?.unsubscribe()
	}

	getCategories(type: 'all' | 'source' | 'destination' = 'all') {
		let type_all = type == 'all'
		let type_source = type == 'source'
		let type_destination = type == 'destination'
		
		this.getCategoriesSub = this.dataService.getCategories()
		.subscribe(
			categories => {
				if (type_source || type_all) this.sourceCategories = []
				if (type_destination || type_all) this.destinationCategories = []

				categories.forEach((category: any) => {
					// console.log(category)
					let obj = {
						'id': category.id,
						'name': category.name
					}

					if (type_source || type_all) {
						this.sourceCategories.push(obj)
					}

					if (type_destination || type_all) {
						this.destinationCategories.push(obj)
					}
				})
			},
			error => {
				console.log(error)
			}
		)
	}

	getCategoryCourses(type: 'source' | 'destination') {
		let type_source = type == 'source'
		let type_destination = type == 'destination'

		let category = 0
		if (type_source) category = this.sourceCategory
		else if (type_destination) category = this.destinationCategory
		if (category == 0) return
		
		this.getCategoryCoursesSub = this.dataService.getCategoryCourses(category)
		.subscribe(
			courses => {
				if (type_source) this.sourceCourses = []
				else if (type_destination) this.destinationCourses = []
				
				courses.forEach((course: any) => {
					// console.log(course)
					let obj = {
						'id': course.id,
						'name': course.name
					}

					if (type_source) this.sourceCourses.push(obj)
					else if (type_destination) this.destinationCourses.push(obj)
				})
			},
			error => {
				console.log(error)
			}
		)
	}

	getCourseUnits(type: 'source' | 'destination') {
		let type_source = type == 'source'
		let type_destination = type == 'destination'

		let course = 0
		if (type_source) course = this.sourceCourse
		else if (type_destination) course = this.destinationCourse
		if (course == 0) return

		this.getCourseUnitsSub = this.dataService.getCourseUnits(course)
		.subscribe(
			units => {
				if (type_source) this.sourceUnits = []
				else if (type_destination) this.destinationUnits = []

				units.forEach((unit: any) => {
					// console.log(unit)
					let obj = {
						'id': unit.id.split('_').pop(),
						'name': unit.text.trim()
					}

					if (type_source) this.sourceUnits.push(obj)
					else if (type_destination) this.destinationUnits.push(obj)
				})
			},
			error => {
				console.log(error)
			},
		)
	}

	getUnitLessons(type: 'source' | 'destination') {
		let type_source = type == 'source'
		let type_destination = type == 'destination'

		let unit = 0
		if (type_source) unit = this.sourceUnit
		else if (type_destination) unit = this.destinationUnit
		if (unit == 0) return

		this.getUnitLessonsSub = this.dataService.getUnitLessons(this.sourceUnit)
		.subscribe(
			lessons => {
				if (type_source) this.sourceLessons = []
				else if (type_destination) this.destinationLessons = []

				lessons.forEach((lesson: any) => {
					// console.log(lesson)
					let obj = {
						'id': lesson.id.split('_').pop(),
						'name': lesson.text.trim()
					}

					if (type_source) this.sourceLessons.push(obj)
					else if (type_destination) this.destinationLessons.push(obj)
				})
			},
			error => {
				console.log(error)
			},
		)
	}

	updateSource(type: string) {
		console.log(type)
		this.name = ''

		// this.getCategoryCourses('all')
		// this.getCourseUnits('all')
		// this.getUnitLessons('all')

		// this.getCategoryCourses('source')
		// this.getCourseUnits('source')
		// this.getUnitLessons('source')
		// this.getCategoryCourses('destination')
		// this.getCourseUnits('destination')
		// this.getUnitLessons('destination')

		if (type == 'category') {
			this.sourceCourse = -1
			this.sourceUnit = -1
			this.sourceLesson = -1
			this.sourceUnits = []
			this.sourceLessons = []

			if (this.type == 'category') {
				this.name = this.sourceCategories?.find((category) => {
					return this.sourceCategory == category.id
				}).name
			} else {
				this.destinationCategory = this.sourceCategory
			}
		} else if (type == 'course') {
			this.getCategoryCourses('source')
			// this.getCourseUnits('source')
			// this.getUnitLessons('source')
			this.sourceCourse = -1
			this.sourceUnit = -1
			this.sourceLesson = -1
			this.sourceLessons = []

			if (this.type == 'course' && this.sourceCourse > 0) {
				this.name = this.sourceCourses?.find((course) => {
					return this.sourceCourse == course.id
				}).name
			} else {
				this.destinationCourse = this.sourceCourse
			}
		} else if (type == 'unit') {
			this.getCourseUnits('source')
			// this.getUnitLessons('source')
			this.sourceUnit = -1
			this.sourceLesson = -1

			if (this.type == 'unit' && this.sourceUnit > 0) {
				this.name = this.sourceUnits?.find((unit) => {
					return this.sourceUnit == unit.id
				}).name
			} else {
				this.destinationUnit = this.sourceUnit
			}
		} else if (type == 'lesson') {
			this.getCourseUnits('source')
			this.getUnitLessons('source')
			if (this.sourceUnit <= 0) this.sourceUnit = -1
			this.sourceLesson = -1

			if (this.type == 'lesson' && this.sourceLesson > 0) {
				this.name = this.sourceLessons?.find((lesson) => {
					return this.sourceLesson == lesson.id
				}).name
			}
		}

		this.updateName()
		// console.log(this.sourceCategory)
		// console.log(this.sourceCourse)
		// console.log(this.sourceUnit)
		// console.log(this.sourceLesson)
	}

	updateDestination(type: string) {
		if (type == 'category') {
			this.getCategoryCourses('destination')
			// this.getCourseUnits('destination')
			// this.getUnitLessons('destination')
			this.destinationCourse = -1
			this.destinationUnit = -1
			this.destinationUnits = []
			this.destinationLessons = []

			if (this.type == 'category') {
				this.name = this.destinationCategories?.find((category) => {
					return this.destinationCategory == category.id
				}).name
			} else {
				// this.destinationCategory = this.sourceCategory
			}
		} else if (type == 'course') {
			this.getCourseUnits('destination')
			// this.getUnitLessons('destination')
			this.destinationUnit = -1
			this.destinationLessons = []

			if (this.type == 'course' && this.destinationCourse > 0) {
				this.name = this.destinationCourses?.find((course) => {
					return this.destinationCourse == course.id
				}).name
			} else {
				// this.destinationCourse = this.sourceCourse
			}
		} else if (type == 'unit') {
			this.getUnitLessons('destination')

			if (this.type == 'unit' && this.destinationUnit > 0) {
				this.name = this.destinationUnits?.find((unit) => {
					return this.destinationUnit == unit.id
				}).name
			} else {
				// this.destinationUnit = this.sourceUnit
			}
		}

		console.log(this.destinationCategory)
		console.log(this.destinationCourse)
		console.log(this.destinationUnit)
	}

	updateName() {
		if (this.name != '') {
			this.duplicateName = this.name + ' (DUPLICADO) (' + new Date().toLocaleDateString('es-ES') +  ')'
			this.showDestination = true
		} else {
			this.duplicateName = ''
			this.showDestination = false
		}
	}

	duplicateNode() {
		if (this.type == 'course') {
			console.log(this.sourceCourse)
			console.log(this.destinationCategory)
			if (this.sourceCourse <= 0) {
				Swal.fire('Error', 'No se ha especificado el curso de origen.', 'error')
				return
			}

			if (this.destinationCategory <= 0) {
				Swal.fire('Error', 'No se ha especificado la categoría de destino.', 'error')
				return
			}
		}

		if (this.type == 'unit') {
			console.log(this.sourceUnit)
			console.log(this.destinationCourse)
			if (this.sourceUnit <= 0) {
				Swal.fire('Error', 'No se ha especificado la unidad de origen.', 'error')
				return
			}

			if (this.destinationCourse <= 0) {
				Swal.fire('Error', 'No se ha especificado el curso de destino.', 'error')
				return
			}
		}

		if (this.type == 'lesson') {
			console.log(this.sourceLesson)
			console.log(this.destinationUnit)
			if (this.sourceLesson <= 0) {
				Swal.fire('Error', 'No se ha especificado la lección de destino.', 'error')
				return
			}

			if (this.destinationUnit <= 0) {
				Swal.fire('Error', 'No se ha especificado la unidad de destino.', 'error')
				return
			}
		}

		this.duplicating = true
		this.duplicateError = false
		this.duplicateSuccess = false

		let sourceChain = `${this.sourceCategory}#${this.sourceCourse}#${this.sourceUnit}#${this.sourceLesson}`
		let destinationChain = `${this.destinationCategory}#${this.destinationCourse}#${this.destinationUnit}`
		console.log(sourceChain)
		console.log(destinationChain)
		// return

		this.duplicateNodeSub = this.dataService.duplicateNode(this.type, sourceChain, this.duplicateName, destinationChain)
		.subscribe(
			data => {
				console.log(data)
				this.duplicating = false
				this.duplicateError = false
				this.duplicateSuccess = true

				if (this.type == 'course') {
					this.destinationCourse = data
				}
			},
			error => {
				console.log(error)
				this.duplicating = false
				this.duplicateError = true
				this.duplicateSuccess = false
			}
		)
	}

}
